import { Expediente } from './Expediente';
import { Recoleccion } from './Recoleccion';
import { Recurso } from './Recurso';
import { Recursos } from './Recursos';

/**
 * RecursosYDatos — la puerta del módulo 15, con sus cuatro zonas.
 *
 * ## Las direcciones
 *
 * | Hash | Qué abre |
 * |---|---|
 * | `#recursos-privados` · `#gestion-conocimiento` | la rejilla de bases de datos |
 * | `#recursos-privados/recurso/<id>` | la tabla de registros de una |
 * | `#recursos-privados/expediente/<id>` | el expediente de un colaborador |
 * | `#gestion-conocimiento/recoleccion` | los formularios de recolección |
 *
 * Los tres primeros alias ya existían —el menú lateral tiene DOS ítems que
 * apuntan a esta misma página y se distinguen solo por la sub-ruta—; las dos
 * direcciones nuevas son las de recurso y expediente, que antes solo vivían en
 * una variable de módulo: el Atrás del navegador salía de la pantalla entera y
 * no se podía enlazar una base de datos concreta.
 *
 * La sub-ruta se lee **una vez, al montar**, y es suficiente porque el router
 * del shell vuelve a montar la capa React en cada `hashchange`: cambiar de zona
 * es siempre un montaje nuevo.
 */
export function RecursosYDatos() {
  const params = window._routeParams ?? [];
  const zona = String(params[0] ?? '');
  const id = Number(params[1]);

  if (zona === 'recoleccion') return <Recoleccion />;
  if (zona === 'recurso' && Number.isFinite(id) && id > 0) return <Recurso id={id} />;
  if (zona === 'expediente' && Number.isFinite(id) && id > 0) return <Expediente userId={id} />;
  return <Recursos />;
}
